module.exports = __webpack_public_path__ + "static/media/Instagram.d21d1e06.svg";